import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PrimaryButtonSto } from 'components/sto';
import { AppRoutes } from 'routes';

import useLocalization from '../../hooks/useLocalization';

const PageNotFoundView = () => {
    const { localizedPush } = useLocalization();
    const handleClick = () => localizedPush(AppRoutes.baseRoute);
    return (
        <div className="page-notfound">
            <h1>
                <FormattedMessage id="pages.notfound.title" />
            </h1>
            <PrimaryButtonSto labelKey="pages.notfound.button" onClick={handleClick} />
        </div>
    );
};

export default PageNotFoundView;
